import { useSEO, generateSchema } from '../../utils/seo';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const BlogDetailPage = () => {
  const { id } = useParams();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yoshino-village-project.com';

  const blogData: { [key: string]: any } = {
    '1': {
      title: '春の植樹イベントを開催しました',
      date: '2024年3月15日',
      datePublished: '2024-03-15',
      category: 'イベント',
      image: 'https://public.readdy.ai/ai/img_res/912dfd256797347165698c96f9435dc1.jpg',
      excerpt: '3月10日、吉野山にて春の植樹イベントを開催しました。地域住民や参加者約50名が集まり、桜の苗木を植樹しました。',
      content: `
        <p>3月10日、吉野山にて春の植樹イベントを開催しました。当日は晴天に恵まれ、地域住民や参加者約50名が集まり、桜の苗木を植樹しました。</p>
        
        <h3>イベントの概要</h3>
        <p>今回の植樹イベントは、吉野の桜を次世代に継承するための重要な取り組みです。参加者は専門家の指導のもと、正しい植樹方法を学びながら、約30本の桜の苗木を植えました。</p>
        
        <h3>参加者の声</h3>
        <p>「初めての植樹体験でしたが、とても楽しかったです。自分が植えた桜が大きく育つのが楽しみです」という声や、「地域のために何かできることがあって嬉しい」といった感想をいただきました。</p>
        
        <h3>今後の予定</h3>
        <p>植樹した桜の成長を見守るため、定期的なメンテナンス活動を予定しています。次回の活動は5月を予定しておりますので、ぜひご参加ください。</p>
      `,
    },
    '2': {
      title: '地域の伝統工芸を学ぶワークショップ',
      date: '2024年3月8日',
      datePublished: '2024-03-08',
      category: '活動報告',
      image: 'https://readdy.ai/api/search-image?query=traditional%20japanese%20craft%20workshop%20with%20artisans%20teaching%20local%20crafts%2C%20hands%20working%20on%20traditional%20materials%2C%20cultural%20heritage%20activity%2C%20warm%20indoor%20lighting%2C%20focused%20atmosphere%2C%20simple%20clean%20background&width=1200&height=600&seq=blog-craft-workshop-detail&orientation=landscape',
      excerpt: '吉野の伝統工芸である木工技術を学ぶワークショップを開催しました。参加者は地域の熟練職人から直接技術を学び、実際に作品を制作する貴重な体験をしました。',
      content: `
        <p>吉野の伝統工芸である木工技術を学ぶワークショップを開催しました。参加者は地域の熟練職人から直接技術を学び、実際に作品を制作する貴重な体験をしました。</p>
        
        <h3>ワークショップの内容</h3>
        <p>今回のワークショップでは、吉野杉を使った小物入れの制作に挑戦しました。木材の選び方から、カンナがけ、組み立てまで、一連の工程を体験していただきました。</p>
        
        <h3>伝統技術の継承</h3>
        <p>吉野の木工技術は数百年の歴史を持つ貴重な文化遺産です。このようなワークショップを通じて、次世代への技術継承と地域文化の保存に貢献していきます。</p>
        
        <h3>参加者の作品</h3>
        <p>参加者の皆さんは、それぞれ個性的な作品を完成させました。初めての方でも、職人の丁寧な指導により、美しい仕上がりとなりました。</p>
      `,
    },
    '3': {
      title: '吉野の四季を巡るフォトツアー',
      date: '2024年2月28日',
      datePublished: '2024-02-28',
      category: 'お知らせ',
      image: 'https://readdy.ai/api/search-image?query=photography%20tour%20group%20in%20yoshino%20mountains%20capturing%20beautiful%20seasonal%20landscapes%2C%20people%20with%20cameras%20enjoying%20nature%2C%20outdoor%20activity%2C%20natural%20lighting%2C%20scenic%20mountain%20views%2C%20simple%20clean%20background&width=1200&height=600&seq=blog-photo-tour-detail&orientation=landscape',
      excerpt: '4月に開催予定のフォトツアーの参加者を募集中です。プロカメラマンと共に吉野の美しい風景を撮影する特別なツアーです。',
      content: `
        <p>4月に開催予定のフォトツアーの参加者を募集中です。プロカメラマンと共に吉野の美しい風景を撮影する特別なツアーです。</p>
        
        <h3>ツアーの詳細</h3>
        <p>開催日：2024年4月20日（土）<br>
        時間：午前9時〜午後4時<br>
        定員：20名<br>
        参加費：5,000円（昼食付き）</p>
        
        <h3>撮影スポット</h3>
        <p>吉野山の桜、古い町並み、山々の風景など、吉野の魅力を存分に撮影できるスポットを巡ります。プロカメラマンが撮影テクニックをアドバイスします。</p>
        
        <h3>お申し込み方法</h3>
        <p>参加ご希望の方は、お問い合わせフォームよりお申し込みください。定員になり次第、受付を終了させていただきます。</p>
      `,
    },
  };

  const blog = blogData[id || '1'] || blogData['1'];

  useSEO({
    title: `${blog.title} | Yoshino Village Project`,
    description: blog.excerpt,
    keywords: `吉野, ${blog.category}, ブログ, 活動報告, イベント`,
    canonical: `${siteUrl}/blog/${id}`,
    ogType: 'article',
    ogImage: blog.image,
    schema: generateSchema.article(
      `${siteUrl}/blog/${id}`,
      blog.title,
      blog.excerpt,
      blog.datePublished,
      blog.image
    ),
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <article className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 text-green-700 font-medium hover:text-green-800 transition-colors mb-8"
            >
              <i className="ri-arrow-left-line"></i>
              ブログ一覧に戻る
            </Link>

            <div className="flex items-center gap-3 mb-6">
              <span className="text-sm text-gray-500">{blog.date}</span>
              <span className="px-3 py-1 bg-green-100 text-green-700 text-xs rounded-full font-medium">
                {blog.category}
              </span>
            </div>

            <h1 className="text-5xl font-black text-gray-900 mb-8 leading-tight">
              {blog.title}
            </h1>

            <div className="rounded-3xl overflow-hidden mb-12 shadow-xl">
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-auto"
              />
            </div>

            <div 
              className="prose prose-lg max-w-none"
              dangerouslySetInnerHTML={{ __html: blog.content }}
              style={{
                lineHeight: '1.8',
              }}
            />

            <div className="mt-16 pt-8 border-t border-gray-200">
              <Link
                to="/blog"
                className="inline-flex items-center gap-2 text-green-700 font-medium hover:text-green-800 transition-colors"
              >
                <i className="ri-arrow-left-line"></i>
                ブログ一覧に戻る
              </Link>
            </div>
          </motion.div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default BlogDetailPage;
